var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          title: "Models",
          shouldShowSearch: _vm.shouldShowSearch,
          toolbarActions: _vm.toolbarActions,
          icon: "style",
          isLoading: _vm.isLoading,
        },
        on: {
          onClicked: (val) => _vm.$emit(val),
          onShouldSearch: (val) => (_vm.searchText = val),
        },
      },
      "Section",
      _vm.$attrs,
      false
    ),
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.modelList,
          search: _vm.searchText,
          "item-key": "id",
          "rows-per-page-items": [15, 25, 50, 100],
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.name)),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.manufacturerList,
                          idKey: "id",
                          idValue: props.item.manufacturerId,
                          propertyKey: "name",
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.categoryList,
                          idKey: "id",
                          idValue: props.item.categoryId,
                          propertyKey: "name",
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.assetCount)),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: props.item.isEnabled ? "green" : "red",
                        },
                      },
                      [_vm._v(_vm._s(props.item.isEnabled ? "done" : "close"))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-right" },
                  [
                    _c("ControlButton", {
                      attrs: {
                        text: "Edit",
                        icon: "edit",
                        iconColor: "warning",
                        disabled: _vm.isLoading,
                      },
                      on: {
                        onClicked: function ($event) {
                          return _vm.$emit("onEditModelClicked", {
                            modelToEdit: props.item,
                          })
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }